import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import NHLogo from '../components/NHLogo';
import api from '../services/api';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.message || 'Invalid or expired reset link');
    }
    setLoading(false);
  };

  if (!token) {
    return (
      <div style={s.container}>
        <div style={s.card}>
          <div style={s.header}><NHLogo size={40} style={{ justifyContent: 'center' }} /></div>
          <p style={{ textAlign: 'center', color: '#991b1b' }}>Invalid reset link. No token provided.</p>
          <div style={{ textAlign: 'center', marginTop: 16 }}><Link to="/login" style={s.link}>Back to Sign In</Link></div>
        </div>
      </div>
    );
  }

  return (
    <div style={s.container}>
      <div style={s.card}>
        <div style={s.header}><NHLogo size={40} style={{ justifyContent: 'center' }} /></div>

        {done ? (
          <div style={{ textAlign: 'center', padding: '20px 0' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>&#10003;</div>
            <h2 style={s.formTitle}>Password Reset</h2>
            <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 20 }}>
              Your password has been updated. You can now sign in with your new password.
            </p>
            <Link to="/login" style={{ ...s.button, display: 'inline-block', textDecoration: 'none', textAlign: 'center', padding: '10px 24px' }}>
              Sign In
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={s.form}>
            <h2 style={s.formTitle}>Set New Password</h2>

            {error && <div style={s.error}>{error}</div>}

            <div style={s.field}>
              <label style={s.label}>New Password</label>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Minimum 8 characters" style={s.input} required />
            </div>
            <div style={s.field}>
              <label style={s.label}>Confirm Password</label>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                placeholder="Re-enter password" style={s.input} required />
            </div>

            <button type="submit" style={{ ...s.button, ...(loading ? { opacity: 0.6 } : {}) }} disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

const s = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(135deg, #7C3AED 0%, #6D28D9 50%, #4C1D95 100%)' },
  card: { background: '#fff', borderRadius: 16, padding: '32px 36px', width: '100%', maxWidth: 400, boxShadow: '0 20px 60px rgba(0,0,0,0.15)' },
  header: { textAlign: 'center', marginBottom: 24 },
  form: {},
  formTitle: { fontSize: 20, fontWeight: 600, color: '#111827', marginBottom: 16, textAlign: 'center' },
  field: { marginBottom: 16 },
  label: { display: 'block', fontSize: 13, fontWeight: 500, color: '#374151', marginBottom: 4 },
  input: { width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, outline: 'none', boxSizing: 'border-box' },
  button: { width: '100%', padding: '10px', background: 'linear-gradient(135deg, #7C3AED, #6D28D9)', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' },
  error: { background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 8, padding: '8px 12px', marginBottom: 16, fontSize: 13, color: '#991b1b' },
  link: { fontSize: 13, color: '#6D28D9', textDecoration: 'none' },
};

export default ResetPassword;
